<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="a-personal-note-on-our-story">
<h1>A Personal Note on Our Story</h1>
<div class="figure">
<img alt="C:\Users\Am\Pictures\PIC\2.jpg" src="Images/file2.jpg" style="width:3.41597in;height:1.98403in"/>
<p class="caption">C:\Users\Am\Pictures\PIC\2.jpg</p>
</div>
<p>This journey we took let us be part of a rural French community for the three months we rented a villa in Aubusson. I wrote a diary most days. I covered the events and people and places and surprises we came across in a totally unfamiliar country and with totally different people to ourselves – the rural French. We also visited a lot of places outside of Aubusson, and in this book I have given the reader an idea of how and where and when to visit this wonderful town. It is in the Creuse department of the Limousin region – about the middle of France.</p>
<p>****</p>
<p>We interacted a great deal with the English who have come to live here and re-built and re-claimed the old barns, making them into somewhat amazing homes.</p>
<p>It was like we were transported into a new world which was incomprehensible to us when we planned our holiday. We suddenly were part of this town and its towns-folk and we changed their lives by our presence. I say this, as on a day-to-day basis, we were willingly made part of their lives within a week of our arrival. What an experience … so we went back a second time!</p>
<p>I have included a lot of history of the area and its major points of interest, which I typed from brochures. This includes the history of tapestry, the terrible German massacre in Oradour-Sur-Glane in World War Two, and the details of the Limousin region – in which Aubusson is located.</p>
<div class="figure">
<img alt="C:\Users\Am\Pictures\PIC\3.jpg" src="Images/file3.jpg" style="width:3.54375in;height:1.66389in"/>
<p class="caption">C:\Users\Am\Pictures\PIC\3.jpg</p>
</div>
<p>by Margaret Rees-Gow</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch007.vue?52021405